export default __webpack_public_path__ + "static/media/check-mailbox-md.e5d5841a.png";